import { Component, EventEmitter, Input, OnInit, Output  } from '@angular/core';
import { ModalService } from 'src/app/services/modal.service';
import { ParticipantThemeService } from 'src/app/services/participant-theme.service';

@Component({
    selector: 'app-modal',
    templateUrl: './modal.component.html',
    styleUrls: ['./modal.component.scss'],
    standalone: false
})

export class ModalComponent implements OnInit {
  @Input() isOpen: boolean = false;
  @Input() title:string="";
  @Input() content:string="";
  @Input() okButtonValue:string="OK";
  @Input() cancelButtonValue:string="Cancel"
  @Input() okButtonText:string="Ok";
  @Input() cancelButtonText:string="Cancel";
  @Input() contentinnerHTML:string="";
  participantClassByRole: string = '';

  //@Inject(MAT_DIALOG_DATA) public data:any
  constructor(private modalService: ModalService,
    private themeService: ParticipantThemeService)
  { }

  ngOnInit(): void {
    this.themeService.setParticipantTheme();
    this.participantClassByRole = this.themeService.participantClassByRole;
  }

  closeModal() {
    this.modalService.closeModal();
    this.modalService.buttonClick(null);
  }

  onButtonClick(button: string) {
    this.modalService.buttonClick(button);
    this.closeModal();
  }
}
